module.exports = __webpack_public_path__ + "static/media/dep-director1.b47fe25b.jpg";